import React, { useEffect } from "react";
import { createUserManager } from "redux-oidc";
import { connect } from "react-redux";

import { OidcConfiguration } from "../configs/oidc";

const IFrameComponent = (props) => {
  const { serverIdentity } = props;

  useEffect(() => {
    const iframeMessageListner = (event) => {
      if (event.data === ("False" || "false")) {
        logoutHandler();
      }
    };

    const checkLoginInterval = setInterval(() => {
      iframePostMessage();
    }, 30 * 1000);

    const cleanup = () => {
      window.removeEventListener("message", iframeMessageListner, false);
      clearInterval(checkLoginInterval);
    };

    window.addEventListener("message", iframeMessageListner, false);

    return cleanup;
  }, []);

  const iframePostMessage = () => {
    if (serverIdentity && serverIdentity.authority) {
      const data = {
        check: "login",
      };
      const domain = `${serverIdentity.authority}/LoggedIn`;
      const iframe = document.getElementById("iframeOP");
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(data, domain);
      }
    }
  };

  const logoutHandler = async () => {
    const { user, serverIdentity } = this.props;

    if (serverIdentity && serverIdentity.authority && user) {
      const logoutManager = createUserManager({
        ...OidcConfiguration,
        ...serverIdentity,
        response_type: "code",
        scope: `openid profile offline_access ${serverIdentity.scope}`,
      });
      await logoutManager.signoutRedirect({ id_token: user.id_token });
    }
  };

  if (!serverIdentity) {
    return null;
  }

  return (
    <iframe
      id="iframeOP"
      title="iframeOP"
      width="0"
      height="0"
      src={`${serverIdentity.authority}/LoggedIn`}
      style={{
        visibility: "hidden",
        position: "absolute",
        display: "none",
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    serverIdentity: state.app.serverIdentity || {
      authority: "",
      client_id: "",
      scope: "asw-api",
    },
  };
};

export default connect(mapStateToProps, undefined)(IFrameComponent);
